// extracted by mini-css-extract-plugin
export default {"inputGroup":"Checkbox_inputGroup__krepv"};